import { render, staticRenderFns } from "./m-orm-crud-table.vue?vue&type=template&id=a3561cc0&scoped=true&lang=pug&"
import script from "./m-orm-crud-table.vue?vue&type=script&lang=js&"
export * from "./m-orm-crud-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3561cc0",
  null
  
)

export default component.exports